import React, { lazy } from 'react';

const CardDeck = lazy(() => import('./CardDeck'));
const PlansCardDeck = lazy(() => import('./PlansCardDeck'));
const CardDeckCaseStudy = lazy(() => import('./CardDeckCaseStudy'));
const CardDeckSlider = lazy(() => import('./CardDeckSlider'));
const CardDeckIndustriesSlider = lazy(() =>
  import('./CardDeckIndustriesSlider')
);
const CardDeckSwitchback = lazy(() => import('./CardDeckSwitchback'));

const CardDeckGenerator = ({ component, slug }) => {
  switch (component?.variant) {
    case 'slider': {
      return <CardDeckSlider component={component} slug={slug} />;
    }
    case 'industries-slider': {
      return <CardDeckIndustriesSlider component={component} slug={slug} />;
    }
    case 'switchback-card-deck': {
      return <CardDeckSwitchback component={component} slug={slug} />;
    }
    case 'case-study': {
      return <CardDeckCaseStudy component={component} slug={slug} />;
    }
    case 'plans': {
      return <PlansCardDeck component={component} slug={slug} />;
    }
    default: {
      return <CardDeck component={component} slug={slug} />;
    }
  }
};

export default CardDeckGenerator;
